import axios from "axios";

export const getProfileViewCounter = () => {
    return axios.get('profiles-view-counter')
}

